<script>
  var images = require.context('../../../assets/auth/img/bg/', true)
  export default {
    name: 'image-bg',
    props: ['image'],
    data () {
      return {
        imageBG: '',
        isLoading: true,
        src: ''
      }
    },
    computed: {},
    mounted () {
      this.src = images('./' + this.image)
      this.$nextTick(() => {
        let img = new Image()
        img.src = this.src
        img.onload = () => {
          this.isLoading = false
          this.imageBG = 'background-image:url("' + img.src + '")'
        }
      })
    },
    destroyed () {
    },
    methods: {},
    components: {}
  }
</script>

<template>
    <div class="bg" :class="{'is-loading' : isLoading}" :style="imageBG"></div>
</template>



// WEBPACK FOOTER //
// ImageBg.vue?07dd535a